import { compose } from 'lodash/fp';

export default compose(
  String,
  Date.now,
);
